import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  Button,
  Modal,
  CircularProgress,
} from '@mui/material';
import PatientDetails from '../Pages/DoctorDashboard/PatientDetails';

const calculateBMI = (weight, height) => {
  if (!weight || !height) return 'N/A';
  const heightInMeters = height / 100;
  const bmi = weight / (heightInMeters * heightInMeters);
  return bmi.toFixed(2);
};

const PatientCard = ({ patient }) => {
  const [modalOpen, setModalOpen] = useState(false);

  if (!patient || !patient.name) {
    return (
      <Box>
        <Typography variant='body1' color='error'>
          No patient data available.
        </Typography>
      </Box>
    );
  }

  const handleViewDetails = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <Card sx={{ marginBottom: 3 }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
          <Avatar sx={{ width: 56, height: 56, marginRight: 2 }}>
            {patient.name ? patient.name.charAt(0) : '?'}
          </Avatar>
          <Box>
            <Typography variant='h6'>{patient.name || 'Unknown'}</Typography>
            <Typography variant='body2'>Age: {patient.age || 'N/A'}</Typography>
            <Typography variant='body2'>
              Gender: {patient.gender || 'N/A'}
            </Typography>
            <Typography variant='body2'>
              Contact: {patient.phone_number || 'N/A'}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ marginBottom: 2 }}>
          <Typography variant='body2'>
            Height: {patient.height || 'N/A'} cm
          </Typography>
          <Typography variant='body2'>
            Weight: {patient.weight || 'N/A'} kg
          </Typography>
          <Typography variant='body2'>
            BMI: {calculateBMI(patient.weight, patient.height)}
          </Typography>
        </Box>
        <Button
          variant='contained'
          color='secondary'
          onClick={handleViewDetails}
        >
          Patient History
        </Button>
      </CardContent>

      {/* Modal for Patient Details */}
      <Modal open={modalOpen} onClose={handleCloseModal}>
        <Box
          sx={{
            maxHeight: '80vh',
            overflowY: 'auto',
            padding: 4,
            backgroundColor: 'white',
            margin: 'auto',
            maxWidth: 800,
            marginTop: '5%',
            borderRadius: 1,
          }}
        >
          {patient.id ? (
            <PatientDetails patientId={patient.id} />
          ) : (
            <CircularProgress />
          )}
          <Button
            variant='contained'
            color='secondary'
            onClick={handleCloseModal}
            sx={{ marginTop: 2 }}
          >
            Close
          </Button>
        </Box>
      </Modal>
    </Card>
  );
};

export default PatientCard;
